import Vue from 'vue'
import {postBlob} from "@/plugins/axios";

// 回款记录分页列表
export function getAccountPageList(data) {
  return Vue.axios({
    url: '/api/account/page_list',
    method: 'post',
    data: {...data,}

  })
}

//导出
export function downloadAccount(data) {
  return postBlob('/api/account/export', data)
}

// 删除回款记录
export function delAccount(data) {
  return Vue.axios({
    url: '/api/account/delete',
    method: 'post',
    data
  })
}

export function reDistributionAmount(data) {
  return Vue.axios({
    url: '/api/account/reDistributionAmount',
    method: 'post',
    data
  })
}

/**
 * 回款异常列表
 * @param params
 * @return {*}
 */
export function accountListException(params) {
  return Vue.axios({
    url: '/api/account/exception_list',
    method: 'get',
    params
  })
}
